<mat-chip-grid #chipList>
  <!-- this is the set of CHIPS that show selected SKILLS (e.g. Adobe Photoshop, etc.) -->
  <mat-chip-row *ngFor="let val of selectedToManyMetas" removable="true" (removed)="removeInValue(val.id)" @appearWidth>
    {{val.name}} ({{val.id}})
    <mat-icon matChipRemove>close</mat-icon>
  </mat-chip-row>

  <span class="autocomplete-input">
    <input [placeholder]="toManyChipsControl.disabled ? 'Loading...' : 'Type to search...'" [matChipInputFor]="chipList"
           [matChipInputAddOnBlur]="true" [formControl]="toManyChipsControl"
           [matChipInputSeparatorKeyCodes]="[13,188]" (matChipInputTokenEnd)="addInValue($event)" matInput [matAutocomplete]="toManyAuto"
           (click)="forceShowToManyDropDown($event)">

    <span *ngIf="searching" @fadeInOut class="input-loading-spinner spinner-border spinner-border-sm"></span>
  </span>

  <!-- this is the list of SKILLS that you select from -->
  <mat-autocomplete #toManyAuto [displayWith]="toManyDisplay.bind(this)" (optionSelected)="toManySelected($event)">
    <mat-option *ngFor="let meta of toManyValues$ | async" [value]="meta.id">
      {{meta.name}} ({{meta.id}})
    </mat-option>
  </mat-autocomplete>
</mat-chip-grid>
